import { Flex, Text, RadioGroup, RadioButton } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { ArenaLockAction, ConfigurationType } from "../constants";
import { isConfigurationType } from "../utils";
import * as styles from "./styles_vanilla.css";

type ConfigurationTypeSelectorProps = {
  selectedAction: ArenaLockAction;
  configurationType: ConfigurationType;
  isLoading: boolean;
  isComplete: boolean;
  onConfigurationTypeChange: (type: ConfigurationType) => void;
};

export const ConfigurationTypeSelector = ({
  selectedAction,
  configurationType,
  isLoading,
  isComplete,
  onConfigurationTypeChange,
}: ConfigurationTypeSelectorProps) => {
  return (
    <div className={styles.configurationSection}>
      <Flex alignItems="center" gap={Sizes.SM} className={styles.sectionHeaderFlex}>
        <Icon type="cog" size="medium" color={Colors.Primary600} />
        <Text variant="strong-md" className={styles.sectionTitle}>
          Configuration Type
        </Text>
      </Flex>
      <Text variant="secondary-md" className={styles.configTypeDescription}>
        Choose how to configure the {selectedAction} operation:
      </Text>

      <RadioGroup
        name="configurationType"
        onChange={(e) => {
          const value = e.target.value;
          if (isConfigurationType(value)) {
            onConfigurationTypeChange(value);
          }
        }}
      >
        <Flex alignItems="center" gap={Sizes.SM}>
          <RadioButton
            value={ConfigurationType.DEFAULT}
            checked={configurationType === ConfigurationType.DEFAULT}
            disabled={isLoading || isComplete}
            name="configurationType"
          >
            <Text variant="secondary-md">Default Configuration</Text>
          </RadioButton>
        </Flex>
        <Flex alignItems="center" gap={Sizes.SM}>
          <RadioButton
            value={ConfigurationType.CUSTOM}
            checked={configurationType === ConfigurationType.CUSTOM}
            disabled={isLoading || isComplete}
            name="configurationType"
          >
            <Text variant="secondary-md">Custom Configuration</Text>
          </RadioButton>
        </Flex>
      </RadioGroup>
    </div>
  );
};
